<template>
  <Head :title="__('content.terms.title')" />

  <Breadcrumbs
    :current-page="__('content.terms.title')"
  />

  <section class="container my-6 md:my-12">
    <h1 class="text-2xl md:text-3xl font-bold mb-4 md:mb-2.5">
      {{ __('content.terms.title') }}
    </h1>
    <p>
      <i18n-t
        keypath="content.terms.text"
        scope="global"
      >
        <template #link>
          <a
            :href="link"
            target="_blank"
          >
            {{ __('content.terms.link-text') }}
          </a>
        </template>
      </i18n-t>
    </p>
  </section>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      required: true,
    },
  },
};
</script>
